import React, { forwardRef, useEffect, useRef } from "react";
import { CustomDropdown } from "@dspworkplace/ui";
import createPersistedState from 'use-persisted-state';
import styled from 'styled-components';
import { getCompanyId, getUserId, useLocalStorage } from "../../Auth";
import { engine } from "../../Utilities/index";
import { StationInclude } from "./schema";

export const useSelectedStation = createPersistedState('selected');

const FakeCss = styled.span`

    .open {
        ul {
            > li {
                padding-left:12px;
                padding-right:12px;
            }
        }
    }
`

const StationSelector = forwardRef(({
    showAllOption = true,
    showLabel = true,
    ...props
}, ref) => {
    const api = engine();

    const value = props.defaultValue || null;
    const [selected, setSelected] = useSelectedStation(value);
    const [stations, setStations] = useLocalStorage('stations', []);
    const observerRef = useRef(null);


    useEffect(() => {
        const params = { actions: { response: {} } };

        if (!stations || !stations.length)
            params.actions.response.Station = {
                "custom":
                {
                    functionName: "getStationByRole",
                    get: 'stations',
                    criteria: {
                        company: getCompanyId(),
                        user: getUserId()
                    },
                    includes: StationInclude
                }
            };

        if (selected === null)
            params.actions.response.Driver = {
                findOneBy: {
                    criteria: {
                        user: getUserId()
                    },
                    get: 'selected',
                    includes: {
                        stations: StationInclude
                    }
                }
            };

        if (!Object.keys(params.actions.response).length)
            return () => { };

        api.post('/api/lazy/manage/data', params).then(
            result => {
                if (result.status === 200) {
                    if (result.data.data.stations)
                        setStations(result.data.data.stations);

                    let id = null;
                    if (result.data.data.selected)
                        id = result.data.data.selected.stations[0].id;

                    let list = result.data.data.stations || stations;

                    if ((list && list.length)
                        && (!id || (id && !list.map(s => s.id).includes(id))))
                        id = list[0].id;

                    if (id)
                        setSelected(id);
                }
            },
            error => { }
        );
    }, []);

    const getOptions = () => {
        let ret = [];

        if (stations.length)
            ret = ret.concat(stations.map(s => ({ value: s.id, name: s.code })));

        if (ret.length)
            ret = ret.sort((a, b) => a.name.localeCompare(b.name))

        return ret;
    };

    const addCheckMark = (selectedStation) => {
        if (observerRef.current) {
            observerRef.current.disconnect();
        }

        const observer = new MutationObserver(() => {
            const allLI = document.querySelectorAll(`.stationSelector li`);
            const li = document.querySelector(`.stationSelector li[value="${selectedStation}"]`);
            if (allLI) {
                allLI.forEach(li => {
                    li.classList.remove('selected-station');
                });
            }
            if (li) {
                li.classList.add("selected-station");
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        observerRef.current = observer;
    }

    useEffect(() => {
        const selectedStation = localStorage.getItem("selected");
        addCheckMark(selectedStation);
        return () => observerRef.current?.disconnect();
    }, []);

    const handleChange = value => {
        if (typeof props.onChange === 'function')
            props.onChange(value);

        setSelected(value);
        const selectedStation = stations.find(station => station.id === value);
        localStorage.setItem("station", JSON.stringify(selectedStation));
        addCheckMark(String(value));
    };

    let defaultValue = value || selected;
    if (props.multiple) {
        if (!Array.isArray(selected))
            defaultValue = [selected];
    } else if (Array.isArray(selected))
        defaultValue = selected[0];

    return (
        <FakeCss className={'test'}>
            <CustomDropdown
                options={getOptions()}
                size={'extraSmall'}
                label={showLabel ? 'Station' : ''}
                ref={ref}
                {...props}
                defaultValue={defaultValue}
                onChange={handleChange}
                visibleOptionsQty={7}
            />
        </FakeCss>
    )
});

export default StationSelector;
